import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoggedActions } from '../modelo/LoggedActions';
import { HttpErrorHandler, HandleError } from '../http-error-handler.service';

import { ApiService } from '../core/services/api.service';
import { map } from 'rxjs/operators';

import { environment } from "src/environments/environment";

import { FiltrosData } from '../modelo/FiltrosData';
import { FiltroData } from '../modelo/FiltroData';

const httpOptions = {
    reportProgress: true,
};

@Injectable()
export class AuditoriaService {

    private apiServer = '';

    private handleError: HandleError;

    constructor(
        private apiService: ApiService,
        private httpClient: HttpClient,
        httpErrorHandler: HttpErrorHandler
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('AuditoriaService');
    }


    listarPorUsuarioFechas(username: string, desde: Date, hasta: Date) {
        if (desde && hasta) {
            const stringparams = `username=${username}&desde=${desde.getTime()}&hasta=${hasta.getTime()}`;
            const params = new HttpParams({ fromString: stringparams });
            //const params = new HttpParams({});
            return this.apiService.get(this.apiServer + '/auditoria', params)
                .pipe(
                    catchError(this.handleError('AuditoriaService.listarPorFechas'))
                )
        } else {
            return this.apiService.get(this.apiServer + '/auditoria')
                .pipe(
                    catchError(this.handleError('AuditoriaService.listarPorFechas'))
                )
        }
    }

    generarReportePorFiltros(uuid: string, filtrosData: FiltrosData) {
        if (uuid) {
            return this.apiService.downloadFileFromPost(`${this.apiServer}/reporte/${uuid}/filtros/download`, filtrosData).pipe(
                catchError(this.handleError('Opeaciones::generarReportePorFiltros', uuid))
            );;
        }
    }
}
